let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("C72jX")).then(() => parcelRequire('5uV65'));